import { useScrollReveal } from '../hooks/useScrollReveal';
import { useParallax } from '../hooks/useParallax';

const tiers = [
  { label: '优秀示范', desc: '可推广的标杆课程', icon: 'ri-star-line', color: 'accent' },
  { label: '稳定达标', desc: '持续达标的日常课程', icon: 'ri-check-double-line', color: 'primary' },
  { label: '重点提升', desc: '需要重点支持的课程', icon: 'ri-arrow-up-circle-line', color: 'accent' },
];

export default function P38QualityTiers({ forceVisible = false }: { forceVisible?: boolean }) {
  const { ref: titleRef, isVisible: titleVisible } = useScrollReveal(0.12, forceVisible);
  const { ref: orb1Ref, offset: orb1Y } = useParallax(0.05);
  const { ref: orb2Ref, offset: orb2Y } = useParallax(-0.04);

  return (
    <div className="relative min-h-screen flex flex-col justify-center overflow-hidden">
      {/* 三层背景光效 */}
      <div ref={orb1Ref} className="absolute top-20 right-24 w-[380px] h-[380px] rounded-full bg-primary-100/14 blur-[130px] pointer-events-none" style={{ transform: `translateY(${orb1Y}px)` }} />
      <div ref={orb2Ref} className="absolute bottom-28 left-12 w-[400px] h-[400px] rounded-full bg-accent-100/12 blur-[120px] pointer-events-none" style={{ transform: `translateY(${orb2Y}px)` }} />
      <div className="absolute top-1/2 left-1/3 w-[300px] h-[300px] rounded-full bg-secondary-200/20 blur-[140px] pointer-events-none animate-orb-float-3" />

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-6 md:py-8">
        <div ref={titleRef} className="text-center mb-4 md:mb-6">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full glass-gold text-accent-700 text-lg font-body font-semibold border border-accent-200/30">
              <i className="ri-scan-line text-base" /> 技术点六
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 transition-all duration-1000 delay-100">
            结果输出与质量分档
          </h2>
        </div>

        {/* 三档阶梯 */}
        <div className="max-w-5xl mx-auto transition-all duration-1000 delay-200">
          <div className="grid grid-cols-3 gap-4 md:gap-5">
            {tiers.map((tier, i) => (
              <div key={tier.label} className={`p-5 md:p-6 rounded-2xl text-center transition-all duration-500 hover:scale-[1.03] ${tier.color === 'primary' ? 'bg-primary-50/60 backdrop-blur-md border border-primary-200/40' : 'bg-accent-50/60 backdrop-blur-md border border-accent-200/40'}`} style={{ transitionDelay: `${200 + i * 100}ms` }}>
                <div className={`w-16 h-16 mx-auto mb-4 rounded-xl flex items-center justify-center ${tier.color === 'primary' ? 'bg-primary-100' : 'glass-gold border-accent-200/40'}`}>
                  <i className={`${tier.icon} text-2xl ${tier.color === 'primary' ? 'text-primary-600' : 'text-accent-600'}`} />
                </div>
                <h3 className={`font-heading text-2xl font-bold ${tier.color === 'primary' ? 'text-primary-700' : 'text-accent-700'}`}>{tier.label}</h3>
                <p className="text-lg text-foreground-950 font-body mt-2">{tier.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}